// Copyright (c) 2017 TrainHeroic LLC
// Actions for User/athlete/coach

const USER_ACTIONS = {
    LOGGED_USER: 'logged-user',
    LOAD_USER_PREFS: 'load-user-prefs'
};

const actions = Object.assign({}, USER_ACTIONS);
export default actions;
